// API calls for the HATTERS service interactions
import { http } from './BackendService';
import { getMobileOperatingSystem, getParameterByName } from '../utils/WindowHelper';
import { signupError } from '../utils/ErrorHandling';
import { AUTH_API_URL } from '../app.config';

export async function handleDaasSignup(signup: IDaasSignup, lang: string | null) {
  let url = `${AUTH_API_URL}/api/services/daas/signup`;
  if (lang) {
    url += `?lang=${lang}`;
  }
  signup.platform = getMobileOperatingSystem();

  const args: RequestInit = {
    method: 'POST',
    cache: 'no-cache',
    body: JSON.stringify(signup),
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  };

  try {
    const res = await http<IDaasSignup>(new Request(url, args));
    if (res.parsedBody) {
      signupSuccess(res.parsedBody);
    }
  } catch (error) {
    signupError(error.value || 0);
  }
}

export async function cancelDaasSignup(signup: IDaasSignup) {
  let url = `${AUTH_API_URL}/api/services/daas/cancel`;
  signup.platform = getMobileOperatingSystem();

  const args: RequestInit = {
    method: 'POST',
    cache: 'no-cache',
    body: JSON.stringify(signup),
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  };

  try {
    const res = await http<IDaasSignup>(new Request(url, args));
    if (res.parsedBody) {
      signupSuccess(res.parsedBody);
    }
  } catch (error) {
    signupError(error.value || 0);
  }
}

function signupSuccess(signup: IDaasSignup): void {
  const redirect = getParameterByName('redirect_uri');

  window.location.href = signup.nextStep || redirect + '?error=hat_provisioning&error_reason=next_step_undefined';
}

export interface IDaasSignup {
  email: string;
  applicationId: string;
  platform?: string;
  tags?: string[];
  redirectUri: string;
  nextStep?: string;
  newsletterOptin?: boolean;
}
